module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/158-egypt-4e190945d9364052e8e374f1cdee4ff0.svg";